(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-one-row"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor(){ super(); }
    connectedCallback(){
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {}; this.currentScrollTop = 0; this.preventReveal = false;
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky','always-fixed');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    disconnectedCallback(){
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver(){
      let observer = new IntersectionObserver((entries,o)=>{ this.headerBounds = entries[0].intersectionRect; o.disconnect(); });
      observer.observe(this.header);
    }
    onScroll(){
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return; requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
        else { window.clearTimeout(this.isScrolling); this.isScrolling = setTimeout(()=>{ this.preventReveal=false; },66); requestAnimationFrame(this.hide.bind(this)); }
      } else if (scrollTop <= this.headerBounds.top) { requestAnimationFrame(this.reset.bind(this)); }
      this.currentScrollTop = scrollTop;
    }
    hide(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); this.closeMenuDisclosure(); }
    reveal(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset(){ if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }
    closeMenuDisclosure(){ this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure'); this.disclosures.forEach(d=>d.close()); }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
	this.header = document.querySelector('.shopify-section-header');
	this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
	this.headerBounds = {};
	this.currentScrollTop = 0;
	this.preventReveal = false;

	if (this.headerIsAlwaysSticky) {
	this.header.classList.add('shopify-section-header-sticky');
	this.header.classList.add('always-fixed');
	};

	this.onScrollHandler = this.onScroll.bind(this);
	this.hideHeaderOnScrollUp = () => this.preventReveal = true;
	this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.addEventListener('scroll', this.onScrollHandler, false);

	this.createObserver();
	}

	disconnectedCallback() {
	this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
	let observer = new IntersectionObserver((entries, observer) => {
	this.headerBounds = entries[0].intersectionRect;
	observer.disconnect();
	});

	observer.observe(this.header);
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (this.preventHide) return;
	requestAnimationFrame(this.hide.bind(this));
	} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (!this.preventReveal) {
	requestAnimationFrame(this.reveal.bind(this));
	}else {
	window.clearTimeout(this.isScrolling);

	this.isScrolling = setTimeout(() => {
	this.preventReveal = false;
	}, 66);

	requestAnimationFrame(this.hide.bind(this));
	}
	} else if (scrollTop <= this.headerBounds.top) {
	requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
	this.closeMenuDisclosure();
	}

	reveal() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}

		hide() {
			super.hide();
			window.pauseAllMedia();
		}

		show(opener) {
			super.show(opener);
			this.showActiveMedia();
		}

		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
			}
			
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
	

  } catch(e) { console.error(e); }
})();
})();
